module.exports = __webpack_public_path__ + "img/nuevo.f084c8f9.png";